import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

import debounce from 'lodash-es/debounce';
import each from 'lodash-es/each';
import SmoothScroll from 'smooth-scroll';
import objectFitImages from 'object-fit-images';
import cookiesEnabled from '../utils/cookiesEnabled.js';
import { wrapTable, wrapIframe } from '../utils/theme-rte.js';

import sections from '../utils/theme-sections';
import '../sections/product';

import * as Infinite from '../infinite-loader';

import 'simplebar';

import RteVideo from '../components/rte-video';

import subNav from '../components/subnav';
import HeaderNav from '../components/HeaderNav';
import mobileNav from '../components/mobileNav';
//import ProductStickyBuy from '../components/ProductStickyBuy';
import ProductImages from '../components/ProductImages';
import Accordion from '../components/Accordion';
// import FindStore from '../components/FindStore';
import ProductOptions from '../components/ProductOptions';
import TrendingCarousel from '../components/TrendingCarousel/index.js';
import ShoppableImage from '../components/ShoppableImage';
// import ChatButtonPosition from '../components/ChatButtonPosition';
import SliderCart from '../components/SliderCart';
// import BackToTopButton from '../components/BackToTopButton';
// import scrollToElement from '../components/scrollToElement';
import ProductOverview from '../sections/ProductOverview';
import StoreDetailArticleContent from '../components/StoreDetailArticleContent';
import Form from '../components/Form';
// import AmbassadorForm from '../components/AmbassadorForm';
// import PressContactForm from '../components/PressContactForm';
// import StoreLocator from '../components/StoreLocator';
// import RecentArticlesCarousel from '../components/RecentArticlesCarousel';
import RevealThumbs from '../components/RevealThumbs';
import RegisterForm from '../components/RegisterForm';
import PreheaderDropdown from '../components/PreheaderDropdown';
// import ArticleTileCustom from '../components/ArticleTileCustom';
import QuickView from '../components/QuickView';
// import AuthorBlock from '../components/AuthorBlock';
import AdMindPageLoad from '../components/AdMind/pageLoad';
import '../components/AdMind/impressionsCertona';
import '../components/AdMind/cart';
import LinkStoreScrollPosition from '../core/linkStoreScrollPosition';
import navMenu from '../components/navMenu';
import HomepagePromoTracking from '../core/HomepagePromoTracking';
//import AdmindRecommendedSlider from '../core/AdmindRecommendedSlider';
import ShippingStatus from '../components/ShippingStatus';
import PDPVideo from '../components/PDPVideo';
import Waitlist from '../components/Waitlist/index.jsx';
import GiftCardProduct from '../components/GiftCardProduct';
import Tooltip from '../components/Tooltip/index.js';

// Footer components
import CountrySelector from '../components/CountrySelector';
import NewsletterSignUp from '../components/NewsletterSignUp';

// Wordpress Modules
// import CMS_2UpImages from '../CMS/CMS-2UpImages';
// import CMS_Blockquote from '../CMS/CMS-Blockquote';
// import CMS_CollectionSlider from '../CMS/CMS-CollectionSlider';
// import CMS_FeaturedProductReview from '../CMS/CMS-FeaturedProductReview';
// import CMS_FlexibleColumns from '../CMS/CMS-FlexibleColumns';
// import CMS_FullWidthImage from '../CMS/CMS-FullWidthImage';
// import CMS_HeroBanner from '../CMS/CMS-HeroBanner';
// import CMS_ImageSlider from '../CMS/CMS-ImageSlider';
// import CMS_ProductSlider from '../CMS/CMS-ProductSlider';
// import CMS_RelatedContent from '../CMS/CMS-RelatedContent';
// import CMS_ShoppableImage from '../CMS/CMS-ShoppableImage';
import CMS_SizeGuide from '../CMS/CMS-SizeGuide';
// import CMS_SplitContent from '../CMS/CMS-SplitContent';
// import CMS_TextHeading from '../CMS/CMS-TextHeading';
// import CMS_Video from '../CMS/CMS-Video';
// import CMS_WysiwygContent from '../CMS/CMS-WysiwygContent';

// *** Auto-generated imports will be placed below. DO NOT EDIT THIS LINE! ***
import Cart from '../sections/Cart';
// import GiftCardHero from '../sections/GiftCardHero';
// import GiftCardPage from '../sections/GiftCardPage';
// import HalloweenBanner from '../sections/HalloweenBanner';
// import HalloweenQuadPods from '../sections/HalloweenQuadPods';
// import HalloweenDualPods from '../sections/HalloweenDualPods';
// import OccassionPage from '../sections/OccassionPage';
// import OccassionDualPods from '../sections/OccassionDualPods';
import SupportContent from '../sections/SupportContent/index';
import SupportHeader from '../sections/SupportHeader/index';
import ArticleThumbCarousel from '../sections/ArticleThumbCarousel/index';
import ArticleCarousel from '../sections/ArticleCarousel/index';
import PressHeading from '../sections/PressHeading/index';
import PressContact from '../sections/PressContact/index';
import PressTagCarousel from '../sections/PressTagCarousel/index';
// import BlogArticleThumbCarousel from '../sections/BlogArticleThumbCarousel/index';
// import BlogLatestGrid from '../sections/BlogLatestGrid/index';
// import UpcomingEvents from '../sections/UpcomingEvents/index';
// import BlogCarousel from '../sections/BlogCarousel/index';
// import BlogLatestPosts from '../sections/BlogLatestPosts/index';
// import BlogFeaturedCarousel from '../sections/BlogFeaturedCarousel/index';
// import BlogLatestPods from '../sections/BlogLatestPods/index';
// import BlogTagsCarousel from '../sections/BlogTagsCarousel/index';
// import BlogMainInterrupterCarousel from '../sections/BlogMainInterrupterCarousel/index';
// import CarouselTimeLine from '../sections/CarouselTimeLine/index';
import HomeTrendingCarousel from '../sections/HomeTrendingCarousel/index';
import FeaturedCarousel from '../sections/FeaturedCarousel/index.jsx';
import SliderCartAddOns from '../sections/SliderCartAddOns/index.js';
import VIPSignup from '../sections/VIPSignup/index';
import CarouselLookBook from '../sections/CarouselLookBook/index';
// import CollectionCarouselSubheading from '../sections/CollectionCarouselSubheading/index';
import PodsAboveBelow from '../sections/PodsAboveBelow/index';
// import ImageTextContent from '../sections/ImageTextContent/index';
import HeroDualImage from '../sections/HeroDualImage/index';
import ProductRecommendationsCarousel from '../sections/ProductRecommendationsCarousel/index.jsx';
import StoreInventorySearch from '../components/React/StoreInventorySearch.jsx';
import VideoPlayerV2 from '../sections/VideoPlayerV2';
// GTM Events
import GTMGlobal from '../components/GTMEvents/index';

// CORE
import iosDisableTabArrows from '../core/iosDisableTabArrows';
import initMonetate from '../core/initMonetate';
import locales_by_country from '../utils/locales_by_country';
import RtbEvents from '../utils/RtbEvents';

window.formatter = new window.Intl.NumberFormat(`${locales_by_country(window.theme.country_iso)}`, {
  style: 'currency',
  currency: window.theme.currency_iso,
  numberingSystem: 'latn',
});

/* ********* IOS 13 FIX - START ********** */

// import flickityiOS13Fix from '../utils/flickityiOS13Fix';

/* Uncomment to test optimizely experiments */

// window.optimizely_mobile_atb = true;
// window.optimizely_certona = {
//   product1: "product1_test_rr",
//   product2: "product2_test_rr",
//   cart: "cart1_test_rr"
// };

// window.optimizely_recommendations = {
//   pageType: 'collection,product',
// };

let startX = 0;

const handleTouchStart = (e) => {
  startX = e.touches[0].clientX;
};

const handleTouchMove = (e) => {
  if (e.touches.length > 1) {
    return;
  }

  if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable) {
    e.preventDefault();
  }
};

const initEventListeners = debounce(() => {
  document.querySelectorAll('.flickity-enabled').forEach((item) => {
    item.removeEventListener('touchstart', handleTouchStart);
    item.removeEventListener('touchmove', handleTouchMove);

    item.addEventListener('touchstart', handleTouchStart);
    item.addEventListener('touchmove', handleTouchMove);
  });
}, 500);

/* ********* IOS 13 FIX - END ********** */

window.clearAllBodyScrollLocks = clearAllBodyScrollLocks;

window.slate = window.slate || {};
window.theme = window.theme || {};

window.addEventListener('DOMContentLoaded', () => {
  /* ********* IOS 13 FIX - START ********** */

  let urlWithParams = new URL(window.location.href);

  if (urlWithParams) {
    let turboLinkParam = urlWithParams.searchParams.get('tl');
    if (turboLinkParam) {
      urlWithParams.searchParams.delete('tl');
      history.replaceState({}, '', urlWithParams.href);
    }
  }

  ProductOverview();

  (function () {
    var p = document.location.protocol;
    if (p == 'http:' || p == 'https:') {
      var m = document.createElement('script');
      m.type = 'text/javascript';
      m.async = true;
      m.src = '//se.monetate.net/js/2/a-a9cab9cd/p/windsorstore.com/custom.js';
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(m, s);
    }
  })();

  initEventListeners();
  document.addEventListener('carouselDidInit', initEventListeners);

  /* ********* IOS 13 FIX - END ********** */

  // Debounce function in vanilla JavaScript
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }

  // Event listener for 'productOverviewCarouselsDidInit'
  document.addEventListener(
    'productOverviewCarouselsDidInit',
    debounce((e) => {
      const params = e.detail;
      const event = new CustomEvent('debouncedProductOverviewCarouselsDidInit', { detail: params });
      document.dispatchEvent(event);
    }, 500),
  );

  /* Global Smooth Scroll method */
  window.smoothScroll = new SmoothScroll('[data-scroll-animation]', {
    speed: 500,
    speedAsDuration: true,
  });

  sections.load('product');

  initMonetate();

  RtbEvents();

  sections.load('product');

  SliderCartAddOns();

  // CMS Modules
  // CMS_2UpImages();
  // CMS_Blockquote();
  // CMS_CollectionSlider();
  // CMS_FeaturedProductReview();
  // CMS_FlexibleColumns();
  // CMS_FullWidthImage();
  // CMS_HeroBanner();
  // CMS_ImageSlider();
  // CMS_ProductSlider();
  // CMS_RelatedContent();
  // CMS_ShoppableImage();
  CMS_SizeGuide();
  // CMS_SplitContent();
  // CMS_TextHeading();
  // CMS_Video();
  // CMS_WysiwygContent();

  // AdMindPageLoad();

  each(Infinite, (component) => {
    component();
  });

  RteVideo();

  subNav();
  HeaderNav();
  mobileNav();
  navMenu();
  //ProductStickyBuy();
  ProductImages();
  Accordion();
  // FindStore();
  ProductOptions();
  TrendingCarousel();
  ShoppableImage();
  // ChatButtonPosition();
  SliderCart();
  // BackToTopButton();

  StoreDetailArticleContent();
  // StoreLocator();
  // RecentArticlesCarousel();
  LinkStoreScrollPosition();
  HomepagePromoTracking();
  //AdmindRecommendedSlider();
  ShippingStatus();
  Waitlist();
  StoreInventorySearch();

  // *** Auto-generated imports will be executed below. DO NOT EDIT THIS LINE! ***
  Tooltip();
  CountrySelector();
  NewsletterSignUp();
  Cart();
  // GiftCardHero();
  // GiftCardPage();
  // HalloweenBanner();
  // HalloweenQuadPods();
  // HalloweenDualPods();
  // OccassionPage();
  // OccassionDualPods();
  // SupportArticleAccordions();
  // SupportArticleThumbs();
  SupportContent();
  SupportHeader();
  ArticleThumbCarousel();
  ArticleCarousel();
  PressHeading();
  PressContact();
  PressTagCarousel();
  // BlogArticleThumbCarousel();
  // BlogLatestGrid();
  // UpcomingEvents();
  // BlogCarousel();
  // BlogLatestPosts();
  // BlogFeaturedCarousel();
  // BlogLatestPods();
  // BlogTagsCarousel();
  // BlogMainInterrupterCarousel();
  // CarouselTimeLine();
  HomeTrendingCarousel();
  // PixleePhotoWall();
  FeaturedCarousel();
  RevealThumbs();
  ProductRecommendationsCarousel();

  // *** Auto-generated imports will be executed below. DO NOT EDIT THIS LINE! ***
  VIPSignup();
  CarouselLookBook();
  // CollectionCarouselSubheading();
  // ImageTextContent();
  VideoPlayerV2();
  HeroDualImage();
  // scrollToElement();
  Form();
  GTMGlobal();
  // AmbassadorForm();
  // PressContactForm();
  RegisterForm();
  PreheaderDropdown();
  //Wishlist();
  // ArticleTileCustom();
  QuickView();
  // AuthorBlock();
  PodsAboveBelow();

  iosDisableTabArrows();

  GiftCardProduct();
  // Fire resize and scroll on page load and section load
  window.dispatchEvent(new Event('resize'));
  window.dispatchEvent(new Event('scroll'));

  document.addEventListener('shopify:section:load', () => {
    window.dispatchEvent(new Event('scroll'));
    window.dispatchEvent(new Event('resize'));
  });

  // Target tables to make them scrollable
  const tableSelectors = '.rte table';

  wrapTable({
    $tables: document.querySelectorAll(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  const iframeSelectors = '.rte iframe[src*="youtube.com/embed"],' + '.rte iframe[src*="player.vimeo"]';

  wrapIframe({
    $iframes: document.querySelectorAll(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper',
  });

  document.addEventListener('shopify:section:load', (e) => {
    if (e.detail.sectionId === 'INF-ArticleContent' || e.detail.sectionId === 'INF-PageContent') {
      wrapIframe({
        $iframes: document.querySelectorAll(iframeSelectors),
        iframeWrapperClass: 'rte__video-wrapper',
      });
    }
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (cookiesEnabled()) {
    document.documentElement.classList.replace('supports-no-cookies', 'supports-cookies');
  }

  document.addEventListener('cartDidOpen', () => {
    setTimeout(() => {
      clearAllBodyScrollLocks();

      document.querySelectorAll('[data-slider-cart-scroll]').forEach((el) => {
        disableBodyScroll(el);
      });
    }, 1);
  });

  objectFitImages();

  /* Initialize PDPVideo component */
  if (document.querySelector('#ProductCarousel')) {
    const pdpVideo = new PDPVideo(document);
    pdpVideo.init(document);
  }

  /* AdMind pageload */
  AdMindPageLoad();
});
